// src/utils/locationCheck.js
//
// An establishment's position (lat/lon, scanned on site by SetLocation) vs
// the address on its record, geocoded by the backend (utils/addressGeocode.ts,
// distance from routes/ShowAllFacilities.ts). Above LOCATION_MISMATCH_M the
// Manager board flags it.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export const LOCATION_MISMATCH_M = 300;

const hasPosition = (f) => !(Number(f.lat) === 0 && Number(f.lon) === 0) && f.lat != null && f.lon != null;

/** 'far' | 'ok' | 'imprecise' | 'notFound' | 'notScanned' | 'pending' */
export function locationStatus(f) {
  if (!hasPosition(f)) return 'notScanned';
  if (!f.address_geocoded_for) return 'pending';
  if (f.address_lat == null || f.address_lon == null) return 'notFound';
  if (Number(f.address_precise) === 0) return 'imprecise';
  const d = Number(f.address_distance_m);
  if (!Number.isFinite(d)) return 'pending';
  return d > LOCATION_MISMATCH_M ? 'far' : 'ok';
}

export const isMislocated = (f) => locationStatus(f) === 'far';

export function formatDistance(m) {
  const d = Number(m);
  if (!Number.isFinite(d)) return '—';
  return d < 1000 ? `${Math.round(d)} m` : `${(d / 1000).toFixed(1).replace('.', ',')} km`;
}

export const osmUrl = (lat, lon) => `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=18/${lat}/${lon}`;

/** « Marquer non localisé » (backend routes/adminUnlocate.ts): { ok, emailSent }. */
export async function unlocateFacility(id, token) {
  const r = await fetch(`${API_BASE_URL}/admin/facilities/${id}/unlocate`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP_${r.status}`);
  return data;
}
